import React from 'react';
import PropTypes from 'prop-types';


const Button = function ButtonComponent({
  onClick,
  className,
  label,
  loader,
  onKeyPress,
  loaderClassName,
}) {
  return (
    <div
      role="button"
      type="button"
      tabIndex={0}
      className={className}
      onClick={onClick}
      onKeyPress={onKeyPress}
    >
      {label}
      {loader && <span className={loaderClassName || `${className}__loader`} /> }
    </div>
  );
};

Button.defaultProps = {
  onClick: undefined,
  className: 'advisor-button',
  loaderClassName: null,
  loader: false,
  onKeyPress: () => (false),
};

Button.propTypes = {
  className: PropTypes.string,
  loaderClassName: PropTypes.string,
  onClick: PropTypes.func,
  label: PropTypes.string.isRequired,
  loader: PropTypes.bool,
  onKeyPress: PropTypes.func,
};

export default Button;
